'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var Icons_WishlistIcon_index = require('../Icons/WishlistIcon/index.js');
require('../viewport.utils-0c2b4e2b.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledWishlistIcon = styled__default['default'](Icons_WishlistIcon_index['default']).withConfig({ displayName: "ww-uikit_StyledWishlistIcon_loy4z4xl", componentId: "sc-16ypy5v" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    z-index: ", ";\n    line-height: 0;\n    cursor: pointer;\n"], ["\n    z-index: ", ";\n    line-height: 0;\n    cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.zIndexProductGridBadges;
});
var WishlistIconButton = function (_a) {
    var isSelected = _a.isSelected, onClick = _a.onClick, _b = _a["data-testid"], testId = _b === void 0 ? 'wishlist-icon' : _b, className = _a.className;
    var _c = React.useState(false), animate = _c[0], shouldAnimate = _c[1];
    var handleClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        shouldAnimate(true);
        if (onClick) {
            onClick(e);
        }
    };
    return (React__default['default'].createElement(StyledWishlistIcon, { className: className, onClick: handleClick, "data-testid": testId, "aria-label": "WishList Icon", isSelected: isSelected, animate: animate }));
};
var templateObject_1;

exports.StyledWishlistIcon = StyledWishlistIcon;
exports.default = WishlistIconButton;
//# sourceMappingURL=index.js.map
